const PinIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={100} cy={100} r={100} fill="#6E0202" fillOpacity={0.2} />
          <path
            d="M93.875 82.625v61.188c0 3.812 2.984 6.937 6.625 6.937s6.625-3.062 6.625-6.937V82.625c15.519-3.25 27.218-17.563 27.218-34.75 0-19.5-15.161-35.375-33.843-35.375-18.682 0-33.783 15.875-33.783 35.375-.06 17.188 11.699 31.5 27.158 34.75z"
            fill="#6E0202"
          />
          <path
            d="M127.24 123.813c-3.343-1.438-7.222.187-8.655 3.687-1.432 3.5.179 7.563 3.522 9.063 9.251 4.062 14.802 10.187 14.802 16.437 0 9.75-14.981 20.688-36.409 20.688-21.487 0-36.41-10.875-36.41-20.688 0-6.187 5.67-12.5 14.743-16.437 3.343-1.5 4.954-5.5 3.522-9.063-1.433-3.5-5.252-5.187-8.655-3.687C59.375 130.063 50.9 141 50.9 153c0 19.375 21.786 34.5 49.6 34.5s49.6-15.125 49.6-34.5c0-12-8.535-22.875-22.86-29.187z"
            fill="#6E0202"
          />
        </svg>
      )
}

export default PinIcon